import React , { useContext } from "react";
import TopBar from "../../scenes/global/Top-Bar";
import ResumeFormat from "../resume_format/resume_format";
import CvTemplate1 from "../../Assets/CVTemplate/cv_template_1.webp";
import CvTemplate2 from "../../Assets/CVTemplate/cv_template_2.webp";
import CvTemplate3 from "../../Assets/CVTemplate/cv_template_3.webp";
import CvTemplate4 from "../../Assets/CVTemplate/cv_template_4.webp";
import CvTemplate5 from "../../Assets/CVTemplate/cv_template_5.webp";
import CvTemplate6 from "../../Assets/CVTemplate/cv_template_6.webp";
import CvTemplate7 from "../../Assets/CVTemplate/cv_template_7.webp";
import { Link } from "react-router-dom";
import BackButton from "../back_button/back_button";
import { useNavigate } from "react-router-dom/dist";
import { useSelector } from "react-redux/es";
import { LanguageContext } from "../../scenes/global/languageContext";

const obj = [
  {
    format: CvTemplate5,
    id: 1,
    name: "Moil Mingle Magic",
  },
  {
    format: CvTemplate2,
    id: 2,
    name: `Essential Avenger`,
  },
  {
    format: CvTemplate3,
    id: 3,
    name: `Freeway Freelancer`,
  },
  {
    format: CvTemplate4,
    id: 4,
    name: `Gig Galaxy Explorer`,
  },
  {
    format: CvTemplate1,
    id: 5,
    name: `Toolbelt Titan`,
  },
  {
    format: CvTemplate6,
    id: 6,
    name: `Skillzilla Showcase`,
  },
  {
    format: CvTemplate7,
    id: 7,
    name: `Code 'n' Wrench Wizard`,
  },
];

export default function UserResumeType() {
  const { language, handleLanguageChange } = useContext(LanguageContext);

  const profile_status = useSelector(element => element.login)
  const navigate = useNavigate();	

  const handleClick = () => {
    if (profile_status.profile_status.profile_status === "true") {
      navigate("/user/dashboard");
    } else if (profile_status.profile_status.profile_status === "false") {
      navigate("/user/dashboard1");
    }
  };

  return (
    <div className="grid grid-rows-dash grid-cols-auto">
      <TopBar />
      <div className="flex flex-col gap-6 justify-center items-center mt-8 max-w-[1028px] mx-auto px-4">
        <BackButton onClick={handleClick} />
        <div className="w-full">
          <p className="text-orange-500 text-base font-normal">
            {language["head"]}
          </p>
        </div>
        <div className="w-full pl-4 sm:pl-8 md:pl-12 py-1.5 bg-white bg-opacity-50 rounded-[40px] shadow border border-indigo-400 border-opacity-30 justify-start items-start gap-2.5 inline-flex">
          <div className="text-stone-950 text-[20px] sm:text-[28px] font-semibold">
            {language["select_resume"]}
          </div>
        </div>
        <div className="w-full grid sm:grid-cols-2 md:grid-cols-3 bg-white bg-opacity-80 rounded-2xl shadow border border-indigo-400 border-opacity-30 gap-6 px-4 py-14 lg:px-10 lg:py-18">
            {obj?.map((data, id) => (
              <a href={`/form/${data.id}/${data.name}`}><ResumeFormat format={data.format}/></a>
            ))}
        </div>
      </div>
    </div>
  );
}
